import { colors } from '../../colors';
var blogList = {
  borderColor: colors.overcast,
  bgColor: colors.white,
  breadcrumbColor: colors.pinkishRed,
  subHeadingColor: colors.pinkishRed,
  headingColor: colors.black,
  paraColor: colors.black,
  blogTileImageRadius: '20px',
  filterTextColor: colors.black
};
export default blogList;